import React from "react";
import { Modal, Button, Typography, Image  } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import "./DeleteConfirmationModal.css";
import deleteImage from "../Assets/commonImages/delete-popup.png";
const { Title, Text } = Typography;
const DeleteConfirmationModal = ({ visible, onConfirm, onCancel }) => {
    return (
        <Modal
        className="addEditCloseBtn"
            open={visible}
            onCancel={onCancel}
            width={400}
            footer={null}
            centered
            closable={false}
        >
           
            <div style={{ textAlign:"center"}}>
            <Image
    src={deleteImage}
    preview={false}
  />
            <Title className="deletePopupHead" style={{marginTop:"5px"}} level={5}>Do you really want to delete this?</Title>
            <Text className="deletePopuptext">Once you delete this member, it cannot be recovered.</Text>
                </div>
            
            <div className="deletePopupBtns" >
            <Button type="primary" className="deletePopupBtn1" block onClick={onConfirm}>
                    Yes, delete it now
                </Button>
                <Button className="deletePopupBtn2" block onClick={onCancel}>Cancel</Button>
               
            </div>
        </Modal>
    );
};

export default DeleteConfirmationModal;
